// extracted by mini-css-extract-plugin
export var banner = "_ox-0";
export var settingRow = "_ox-2";
export var titleIcon = "_ox-1";